import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CmgService } from '../../shared/services/cmg.service';

@Component({
  selector: 'app-cmg',
  templateUrl: './cmg.component.html',
  styleUrls: ['./cmg.component.scss']
})
export class CmgComponent implements OnInit {

  requests: any;
  constructor(
    private router: Router,
    private cmgService: CmgService
    ) { }

  ngOnInit(): void {
    this.getCMG();
  }
  editCMG(e){
    this.router.navigate([`/dash/cmg/edit/${e}`]);
  }
  onDeleteCMG(e){
    this.cmgService.onDeleteCMG(e).subscribe(res =>{
      console.log("CMG Borrado", res);
      this.getCMG();
    });
  }
  addCMG() {
    this.router.navigate(['/dash/cmg/new']);
  }
  getCMG(){
    this.cmgService.getCMG().subscribe(res =>{
      this.requests = res.data;
    });
  }
  
}
